import { DEFAULT_ELEMENT, type TypographyBaseProps } from "./types";
import { buildTypographyClasses } from "./utils";

export interface TextProps extends TypographyBaseProps {
  /** Render inline instead of block (spans a line). */
  inline?: boolean;
}

export function Text({
  variant,
  tone,
  as,
  className,
  children,
  inline = false,
  dir,
  lang,
  "data-testid": dataTestId,
  ...rest
}: TextProps) {
  const Component = as ?? (inline ? "span" : DEFAULT_ELEMENT[variant]);
  const classes = buildTypographyClasses({ variant, tone, className });

  return (
    <Component
      className={classes}
      dir={dir}
      lang={lang}
      data-testid={dataTestId}
      {...rest}
    >
      {children}
    </Component>
  );
}
